<app-login-as-notice></app-login-as-notice>
<router-outlet></router-outlet>
<!-- <div class="environment_notice" *ngIf="branch && backend && !(backend ==='portal.payquad.com' || backend === 'medallion.payquad.com')">
    <span>Branch: {{branch}}</span>
    <span>Env: {{backend}}</span>
</div> -->